import GrammaPro from './model';
import immutable from 'immutable';

const reviver = ([key, val]) => {
  switch (key) {
    case 'studentId':
      return [key, `${val}`];
    default:
      return [key, immutable.fromJS(val)];
  }
};

const create = (data) => new GrammaPro(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/GrammaPro/model/create.js